import { render, staticRenderFns } from "./ModalDetailTeam.vue?vue&type=template&id=ca6c5020&scoped=true"
import script from "./ModalDetailTeam.vue?vue&type=script&lang=js"
export * from "./ModalDetailTeam.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca6c5020",
  null
  
)

export default component.exports